module.exports = __webpack_public_path__ + "static/media/logo-asturiana.9fe7b518.jpg";